import { render, JSX } from 'preact/compat';
import {
  EmailShareButton,
  FacebookShareButton,
  PocketShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import { pingMatomo } from '@ts/helpers/analytics';
import { Icon } from '../Icon/Icon';

const CopyUrlButton = () => {
  const url = window.location.href;
  navigator.clipboard
    .writeText(url)
    .then(() => {
      (document.activeElement as HTMLElement).blur();
      window.focus();
    })
    .catch(err => {
      console.error('Failed to copy: ', err);
    });
  // eslint-disable-next-line no-alert
  window.alert('Der Link wurde erfolgreich in die Zwischenablage kopiert');
};

// Complenent for social menu icons and links for social media
export const shareMenuItems = (): JSX.Element => {
  const location = window.location.href;
  const tag = document
    .querySelector('.bc-article-intro__title__topic')
    ?.textContent?.replace(/[^a-zA-Z]/g, '');
  const text =
    document.querySelector('.bc-article-intro__text')?.textContent || '';
  const title = tag ? `#${tag}: ${text}` : text;

  return (
    <div className="bc-flyout__items">
      <TwitterShareButton title={title} url={location} via="derfreitag">
        <div className="bc-flyout__icon-wrapper" style={{ marginLeft: '2px' }}>
          <Icon iconName="twitter" width={20} height={20} title="X-Symbol" />
          <p>X</p>
        </div>
      </TwitterShareButton>

      <FacebookShareButton title={title} url={location}>
        <div className="bc-flyout__icon-wrapper">
          <Icon
            iconName="facebook"
            width={24}
            height={24}
            title="Facebook-Symbol"
          />
          <p>Facebook</p>
        </div>
      </FacebookShareButton>

      <PocketShareButton url={location} title={title}>
        <div className="bc-flyout__icon-wrapper">
          <Icon
            iconName="pocket"
            width={24}
            height={24}
            title="Pocket-Symbol"
          />
          <p>Pocket</p>
        </div>
      </PocketShareButton>

      <WhatsappShareButton title={title} url={location}>
        <div className="bc-flyout__icon-wrapper">
          <Icon
            iconName="whatsapp"
            width={24}
            height={24}
            title="Whatsapp-Symbol"
          />
          <p>Whatsapp</p>
        </div>
      </WhatsappShareButton>
      <EmailShareButton
        url={`mailto:?subject=Der%20Freitag%20Article&body=${location}`}
      >
        <div className="bc-flyout__icon-wrapper">
          <Icon iconName="email" width={24} height={24} title="EMail-Symbol" />
          <p>E-Mail</p>
        </div>
      </EmailShareButton>

      <button onClick={CopyUrlButton} className="react-share__ShareButton">
        <div className="bc-flyout__icon-wrapper">
          <Icon
            iconName="copy"
            width={24}
            height={24}
            title="Link kopieren Symbol"
          />
          <p>Link kopieren</p>
        </div>
      </button>
    </div>
  );
};

// Utility function to detect the device type
const detectDeviceType = () =>
  /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent)
    ? 'Mobile'
    : 'Desktop';

// Main component for creating the social share menu
export const SocialShareMenu = (): JSX.Element => {
  const deviceType = detectDeviceType();
  const location = window.location.href;

  // There are two buttons and two menus on the page: on the header and on the article
  const shareButtons = document.querySelectorAll<HTMLElement>('.bc-flyout');
  const socialShareMenus =
    document.querySelectorAll<HTMLElement>('.pts-socialmedia');

  shareButtons.forEach(shareButton => {
    shareButton.addEventListener('click', () => {
      pingMatomo('social');
      // We are setting the focus for the share buttons here because Safari doesn't
      // mark the clicked buttons as focused automatically.
      shareButton.focus();

      // If the device is mobile, it will show the native sharing menu
      // Mobile devices that doesn't have native sharing options, it will
      // fallback to default social sharing menu
      if (deviceType === 'Mobile' && navigator.share) {
        socialShareMenus.forEach(socialShareMenu => {
          const menu = socialShareMenu;
          menu.style.display = 'none';
        });

        // Calls the native sharing menu
        navigator
          .share({
            title: 'Der Freitag',
            url: location,
          })
          .catch(error => console.error('Error sharing:', error));
      }
    });
  });

  return shareMenuItems();
};

// Loop through all instances of `.pts-socialmedia` and render the SocialShareMenu
document.querySelectorAll('.pts-socialmedia').forEach(menuElement => {
  render(<SocialShareMenu />, menuElement);
});
